import { Button, ScaledHeading } from "@/components";
import { useState } from "react";
import Styles from "./IndustryCourses.module.css";
import { PrismicRichText } from "@prismicio/react";
import { VideoPlayer } from "@/components";
import { PrismicNextImage } from "@prismicio/next";

/**
 * @typedef {import("@prismicio/client").Content.IndustryCoursesSlice} IndustryCoursesSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<IndustryCoursesSlice>} IndustryCoursesProps
 * @param {IndustryCoursesProps}
 */

const IndustryCourses = ({ slice: { primary }, industries, courses }) => {
	const [active, setActive] = useState({
		index: 0,
		industry: industries[0].uid,
	});

	const handleClick = (index, industry) => {
		setActive({ index: index, industry: industry?.uid });
	};

	return (
		<section className={Styles.wrapper}>
			<div className={Styles.mainContainer}>
				<ScaledHeading heading="Industries" margin="0" />
				<div className={Styles.btnContainer}>
					{industries
						.sort(
							(a, b) =>
								(a?.data?.priority || Infinity) -
								(b?.data?.priority || Infinity)
						)
						.map((industry, index) => (
							<button
								className={Styles.industryBtn}
								key={index}
								onClick={() => handleClick(index, industry)}
								data-active={active.industry === industry.uid}
							>
								{industry?.data?.industry_name}
							</button>
						))}
				</div>
				<div className={Styles.contentContainer}>
					<h2>{industries[active.index]?.data?.industry_name}</h2>
					<PrismicRichText
						field={industries[active.index]?.data?.description}
					/>
					<Button
						link={{
							link_type: "Document",
							url: `/training/courses?industry=${
								industries[active.index]?.uid
							}`,
						}}
						label="View All Courses"
					/>
				</div>
			</div>
			<div className={Styles.whiteContainer}></div>
			<div
				className={Styles.background}
				style={{
					backgroundImage: industries[active.index]?.data?.background_image?.url
						? `url(${industries[active.index].data.background_image.url})`
						: undefined,
				}}
			></div>
			<div className={Styles.videoContainer} data-contain="true">
				<VideoPlayer
					videoUrl={primary?.video?.url}
					videoType="native"
					theme={{
						primary: "var(--red)",
						secondary: "var(--dark-grey)",
						icon: "var(--white)",
					}}
					autoPlay={false}
				/>
				<PrismicNextImage
					className={Styles.foregroundImage}
					field={industries[active.index]?.data?.industry_foreground_image}
				/>
			</div>
		</section>
	);
};

export default IndustryCourses;
